'use client'

import { cn } from '@/lib/utils'
import { useStoreI18n } from '@/store'
import { memo, useEffect, useEffectEvent, useState } from 'react'
import Button from '../Button/Button'

interface Props extends React.HTMLAttributes<HTMLDivElement> {
  mode?: 'invert'
}

const LangSwitch = ({ className, mode, ...props }: Props) => {
  //States
  const [routes, setRoutes] = useState<
    {
      link: string
      twoLetterIsoCode: string
      available: boolean
      title: string
    }[]
  >([])

  //Stores
  const currentRoutes = useStoreI18n.use.currentRoutes()
  const locale = useStoreI18n.use.currentLocale()

  const handleSetRoutes = useEffectEvent(
    (
      splitRoutes: {
        available: boolean
        link: string
        twoLetterIsoCode: string
        title: string
      }[]
    ) => {
      setRoutes(splitRoutes)
    }
  )

  useEffect(() => {
    if (currentRoutes && currentRoutes.length > 0) {
      const splitRoutes = currentRoutes.map((route) => {
        const { available, link, twoLetterIsoCode, title } = route
        return {
          available: Boolean(available),
          link,
          twoLetterIsoCode,
          title
        }
      })
      handleSetRoutes(splitRoutes)
    }
  }, [currentRoutes])

  if (routes?.length === 1) {
    return null
  }

  return (
    <div className={cn(`gap-gutter relative flex`, className)} {...props}>
      {routes?.map((route, index) => (
        <div key={index?.toString()}>
          <Button
            href={route.link}
            variant="text"
            mode={mode}
            size="s"
            isCurrent={locale === route.twoLetterIsoCode}
          >
            {route.title}
          </Button>
        </div>
      ))}
    </div>
  )
}

export default memo(LangSwitch)
